import { createApp } from 'vue';
import { createPinia } from 'pinia';

import './style.css';
import App from './App.vue';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from 'system/firebase.js';
import { useContextStore } from 'store/context.js';
import { router } from 'routes/routes.js';

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);

let isAppMounted = false;

onAuthStateChanged(auth, async (user) => {
    const context = useContextStore();

    if (user) {
        const token = await user.getIdToken(false);

        await context.authenticate(user, token);
    } else {
        await context.deauthenticate();
    }

    // Mount the app only after the first auth state change
    if (!isAppMounted) {
        app.use(router);
        app.mount('#app');
        console.log('Created and mounted Vue APP');
        isAppMounted = true;
    }
});
